module.exports = __webpack_public_path__ + "media/svg-new/avatar-2 5-0cb99734.svg";